import { useApi } from "../../../swr/useApi";
import { adminPaymentsService } from "../../api_client";
import type { AdminStatsDto } from "../../../api";

export function useAdminStats(startDate?: string, endDate?: string) {
  const key = `admin-stats-${startDate ?? ""}-${endDate ?? ""}`;
  return useApi<AdminStatsDto>(key, () =>
    adminPaymentsService.adminGetStats(startDate, endDate),
  );
}
